export default __webpack_public_path__ + "assets/images/169baa41a6b9a02d0e991ce9e27ecc12.svg";